<div class="dialog">
  <div class="dialog__header">
    <div>
      <h2 class="dialog__title">Week of {{ week.weekStart }}</h2>
      <p class="dialog__subtitle">{{ week.regionName }}</p>
    </div>
    <button mat-icon-button (click)="close()" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog__verdict">
    <lohi-eligibility-status-chip [eligible]="week.carrierEligible"></lohi-eligibility-status-chip>
  </div>

  <div class="dialog__override" *ngIf="week.override as override">
    <div class="dialog__override-badge">
      <mat-icon>flag</mat-icon>
      <span>Manual override</span>
    </div>
    <p>
      Overridden on {{ override.overriddenAt | date: 'medium' }} by <strong>{{ override.overriddenBy }}</strong
      >. Original evaluator verdict was
      <strong>{{ override.previousCarrierEligible ? 'Eligible' : 'Not eligible' }}</strong
      >.
    </p>
    <p class="dialog__override-note">
      The rule breakdown below describes the evaluator's <em>original</em> opinion (pre-override).
    </p>
  </div>

  <div class="dialog__section">
    <h3>Daily capacity rule</h3>
    <ng-container *ngIf="week.effectiveBreakdowns?.dailyCapacityRule as dc; else noBreakdown">
      <div class="dialog__rule-meta">
        <span>Status:</span>
        <span [class.dialog__pass]="dc.passed" [class.dialog__fail]="!dc.passed">
          {{ dc.passed ? 'Passed' : 'Failed' }}
        </span>
      </div>
      <ul class="dialog__list">
        <li>
          Peak weekday drivers (Mon-Thu): <strong>{{ dc.maxWeekday }}</strong>
        </li>
        <li>
          Peak weekend drivers (Fri-Sun): <strong>{{ dc.maxWeekend }}</strong>
        </li>
        <li>
          Ratio: <strong>{{ dc.ratio | number: '1.2-2' }}</strong> (required ≥ {{ dc.requiredRatio | number: '1.2-2' }})
        </li>
      </ul>
      <div class="dialog__daily">
        <span class="dialog__daily-title">Drivers per day</span>
        <div class="dialog__daily-grid">
          <div
            *ngFor="let cell of dailyCountCells(dc.dailyCounts); trackBy: trackByDayKey"
            class="dialog__daily-cell"
            [class.dialog__daily-cell--weekend]="cell.isWeekend"
          >
            <div class="dialog__daily-day">{{ cell.label }}</div>
            <div class="dialog__daily-count">{{ cell.count }}</div>
          </div>
        </div>
        <p class="dialog__daily-legend">
          Weekday peak (Mon-Thu) <strong>{{ dc.maxWeekday }}</strong> · Weekend peak (Fri-Sun)
          <strong>{{ dc.maxWeekend }}</strong>
        </p>
      </div>
    </ng-container>
  </div>

  <div class="dialog__section dialog__section--meta" *ngIf="week.effectiveBreakdowns as bd">
    <span *ngIf="bd.regionTimezone"
      >Timezone: <strong>{{ bd.regionTimezone }}</strong></span
    >
  </div>

  <ng-template #noBreakdown>
    <p class="dialog__empty">Not evaluated for this week.</p>
  </ng-template>
</div>
